import React, { Component } from 'react'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import { Link } from 'react-router-dom'
import AuthenticationService from '../general/AuthenticationService.js'

class PersonaFisicaReporteComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            apellidoMaterno: '', apellidoPaterno: '',
            curp: '', rfc: '', nombre: '',
            documentos: [], domicilios: [],
            entidadesRolesComentarios: [],
            curpFileUrl: '', cifFileUrl: '', ineFileUrl: '',
            vigenciaIne: '',
            impresionPantallaIneFileUrl: '',
            vigenciaImpresionPantallaIne: '',
            loading: true,
        }
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_PERSONAS_FISICAS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        if (Number(this.props.match.params.id) === -1) return

        ElementsDataService.retrieveElement("personas-fisicas", this.state.id).then(r => {
            const d = r.data
            this.setState({
                apellidoMaterno: d.apellidoMaterno || '',
                apellidoPaterno: d.apellidoPaterno || '',
                curp: d.curp || '', rfc: d.rfc || '', nombre: d.nombre || '',
                domicilios: d.domicilios || [],
                documentos: d.documentos || [],
                entidadesRolesComentarios: d.entidadesRolesComentarios || [],
                curpFileUrl: d.curpFileUrl || '',
                cifFileUrl: d.cifFileUrl || '',
                ineFileUrl: d.ineFileUrl || '',
                vigenciaIne: d.vigenciaIne || '',
                impresionPantallaIneFileUrl: d.impresionPantallaIneFileUrl || '',
                vigenciaImpresionPantallaIne: d.vigenciaImpresionPantallaIne || '',
                loading: false,
            })
        })
    }

    download(url, name) {
        ElementsDataService.downloadS3File(`?fileName=${url}`, `${name}.pdf`)
    }

    render() {
        const {
            id, apellidoMaterno, apellidoPaterno, curp, rfc, nombre,
            documentos, domicilios, entidadesRolesComentarios,
            curpFileUrl, cifFileUrl, ineFileUrl, vigenciaIne,
            impresionPantallaIneFileUrl, vigenciaImpresionPantallaIne,
            loading,
        } = this.state

        const fullName = `${nombre} ${apellidoPaterno} ${apellidoMaterno}`.trim()
        const fileBase = `${apellidoPaterno}_${apellidoMaterno}_${nombre}`

        // Avatar
        const initials = ((apellidoPaterno || '').charAt(0) + (nombre || '').charAt(0)).toUpperCase() || '?'
        const avatarColors = ['#3b82f6','#8b5cf6','#ec4899','#f59e0b','#10b981','#06b6d4']
        const avatarBg = avatarColors[(apellidoPaterno || '').charCodeAt(0) % avatarColors.length] || '#3b82f6'

        // Vigencia helpers
        const fmtVigencia = v => {
            if (!v || v === '1900-01-01') return null
            return v
        }
        const ineVigente = vigenciaIne && vigenciaIne !== '1900-01-01'
        const pantVigente = vigenciaImpresionPantallaIne && vigenciaImpresionPantallaIne !== '1900-01-01'

        return (
            <div style={S.root}>
                <style>{css}</style>
                <div className="pfr-root" style={S.inner}>

                    {/* Header */}
                    <div style={S.header}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                            <div style={{ width: 56, height: 56, borderRadius: '50%', background: avatarBg, color: 'white', fontSize: '1.2rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: `0 4px 16px ${avatarBg}55` }}>
                                {loading ? '?' : initials}
                            </div>
                            <div>
                                <p style={S.breadcrumb}>
                                    <span style={{ color: '#3b82f6', cursor: 'pointer' }} onClick={() => this.props.history.push('/personas-fisicas')}>Personas Físicas</span>
                                    <span style={{ margin: '0 8px', color: '#cbd5e1' }}>›</span>
                                    <span>Reporte</span>
                                </p>
                                <h1 style={S.title}>{loading ? 'Cargando...' : fullName}</h1>
                                {rfc && <p style={{ margin: '3px 0 0', fontFamily: 'monospace', fontSize: '0.85rem', color: '#64748b', letterSpacing: 1 }}>{rfc}</p>}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            {AuthenticationService.haveAuthorization("WRITE_PERSONAS_FISICAS") && (
                                <button style={S.btnEdit} onClick={() => this.props.history.push(`/personas-fisicas/${id}`)}>✏️ Editar</button>
                            )}
                            {AuthenticationService.haveAuthorization("WRITE_PERSONAS_FISICAS") && (
                                <button style={S.btnAdd} onClick={() => this.props.history.push('/personas-fisicas/-1')}>+ Nueva</button>
                            )}
                        </div>
                    </div>

                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
                            <div className="pfr-spinner" />
                        </div>
                    ) : (
                        <>
                            {/* Fila superior: datos + domicilios */}
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>

                                {/* Datos personales */}
                                <Card icon="👤" title="Datos Personales">
                                    <InfoRow label="Apellido Paterno" value={apellidoPaterno} />
                                    <InfoRow label="Apellido Materno" value={apellidoMaterno} />
                                    <InfoRow label="Nombre(s)" value={nombre} />
                                    <InfoRow label="RFC" value={
                                        <span style={{ fontFamily: 'monospace', fontWeight: 700, color: '#1e293b', letterSpacing: 1 }}>{rfc}</span>
                                    } />
                                    <InfoRow label="CURP" value={
                                        <span style={{ fontFamily: 'monospace', fontSize: '0.82rem', color: '#475569' }}>{curp || '—'}</span>
                                    } />
                                </Card>

                                {/* Domicilios */}
                                <Card icon="📍" title="Domicilios">
                                    {!domicilios?.length ? (
                                        <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.82rem' }}>Sin domicilios registrados</p>
                                    ) : domicilios.map(d => (
                                        <Link key={d.id} to={`/domicilios/reportes/${d.id}`}
                                            style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: '1px solid #f1f5f9', textDecoration: 'none' }}>
                                            <span style={{ color: '#94a3b8' }}>📍</span>
                                            <span style={{ fontSize: '0.83rem', color: '#2563eb', fontWeight: 600 }}>{d.calle} {d.numeroExt}</span>
                                        </Link>
                                    ))}
                                </Card>
                            </div>

                            {/* Documentos de identidad */}
                            <Card icon="🪪" title="Documentos de Identidad" style={{ marginBottom: 14 }}>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
                                    <DocTile
                                        label="CURP"
                                        subtitle={curp}
                                        url={curpFileUrl}
                                        fileName={`CURP_${fileBase}_${curp}`}
                                        onDownload={(u, n) => this.download(u, n)}
                                    />
                                    <DocTile
                                        label="INE"
                                        subtitle={ineVigente ? `Vigencia: ${vigenciaIne}` : '⚠ No vigente'}
                                        subtitleColor={ineVigente ? '#16a34a' : '#f59e0b'}
                                        url={ineFileUrl}
                                        fileName={`INE_${fileBase}_${curp}`}
                                        onDownload={(u, n) => this.download(u, n)}
                                    />
                                    <DocTile
                                        label="Impresión Pantalla INE"
                                        subtitle={pantVigente ? `Vigencia: ${vigenciaImpresionPantallaIne}` : vigenciaImpresionPantallaIne === '1900-01-01' ? '⚠ No vigente' : ''}
                                        subtitleColor={pantVigente ? '#16a34a' : '#f59e0b'}
                                        url={impresionPantallaIneFileUrl}
                                        fileName={`INE_Pantalla_${fileBase}_${curp}`}
                                        onDownload={(u, n) => this.download(u, n)}
                                    />
                                    <DocTile
                                        label="CIF"
                                        url={cifFileUrl}
                                        fileName={`CIF_${fileBase}_${curp}`}
                                        onDownload={(u, n) => this.download(u, n)}
                                    />
                                </div>
                            </Card>

                            {/* Tabla documentos/sociedades/roles */}
                            {documentos?.length > 0 && (
                                <div style={{ background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 22px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }}>
                                        <span>📄</span>
                                        <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }}>Documentos Vinculados</h2>
                                        <span style={{ marginLeft: 'auto', fontSize: '0.72rem', background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 12, padding: '2px 10px', fontWeight: 700 }}>{documentos.length}</span>
                                    </div>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr>
                                                    <th className="pfr-th">Sociedades</th>
                                                    <th className="pfr-th">Documento / Asunto</th>
                                                    <th className="pfr-th">Roles</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documentos.map(doc => {
                                                    const rolesDoc = entidadesRolesComentarios.filter(r => r.documentoId == doc.id)
                                                    return (
                                                        <tr key={doc.id} className="pfr-tr">
                                                            <td className="pfr-td">
                                                                {doc.sociedades?.map(s => (
                                                                    <Link key={s.id} to={`/sociedades/reportes/${s.id}`}
                                                                        style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, textDecoration: 'none', color: '#2563eb', fontSize: '0.82rem', fontWeight: 600 }}>
                                                                        🏢 {s.razonSocial}
                                                                    </Link>
                                                                ))}
                                                            </td>
                                                            <td className="pfr-td">
                                                                <Link to={`/documentos/reportes/${doc.id}`}
                                                                    style={{ textDecoration: 'none', color: '#334155', fontWeight: 600, fontSize: '0.83rem' }}>
                                                                    {doc.asuntos || doc.tipoDocumento}
                                                                </Link>
                                                                {doc.fecha && <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 2 }}>📅 {doc.fecha}</div>}
                                                            </td>
                                                            <td className="pfr-td">
                                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                    {rolesDoc.map((r, i) => (
                                                                        <span key={i} style={{ fontSize: '0.72rem', fontWeight: 600, padding: '2px 8px', borderRadius: 12, background: '#f5f3ff', color: '#7c3aed', border: '1px solid #ddd6fe' }}>
                                                                            {r.rol}
                                                                        </span>
                                                                    ))}
                                                                    {rolesDoc.length === 0 && <span style={{ color: '#cbd5e1', fontSize: '0.78rem' }}>—</span>}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        )
    }
}

/* ── Subcomponentes ── */
const Card = ({ icon, title, children }) => (
    <div style={{ background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 22px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }}>
            <span>{icon}</span>
            <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }}>{title}</h2>
        </div>
        <div style={{ padding: '16px 22px' }}>{children}</div>
    </div>
)

const InfoRow = ({ label, value }) => (
    <div style={{ display: 'flex', gap: 12, marginBottom: 10, alignItems: 'flex-start' }}>
        <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.8px', textTransform: 'uppercase', minWidth: 110, paddingTop: 2, flexShrink: 0 }}>{label}</span>
        <span style={{ fontSize: '0.85rem', color: '#334155', flex: 1 }}>{value || '—'}</span>
    </div>
)

const DocTile = ({ label, subtitle, subtitleColor = '#64748b', url, fileName, onDownload }) => (
    <div style={{ border: '1px solid #e2e8f0', borderRadius: 12, padding: '14px 16px', background: url ? '#f8fafc' : '#fafafa', display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: '1.2rem' }}>{url ? '📄' : '📭'}</span>
            <span style={{ fontWeight: 700, fontSize: '0.82rem', color: '#1e293b' }}>{label}</span>
        </div>
        {subtitle && <p style={{ margin: 0, fontSize: '0.72rem', color: subtitleColor, fontWeight: 500 }}>{subtitle}</p>}
        {url ? (
            <button
                onClick={() => onDownload(url, fileName)}
                style={{ marginTop: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '7px 0', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 8, color: 'white', fontWeight: 600, fontSize: '0.78rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}>
                ⬇ Descargar
            </button>
        ) : (
            <p style={{ margin: 'auto 0 0', fontSize: '0.72rem', color: '#cbd5e1' }}>Sin archivo</p>
        )}
    </div>
)

const css = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
    .pfr-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
    .pfr-th { padding: 9px 16px; text-align: left; font-size: 0.68rem; font-weight: 700; color: #64748b; letter-spacing: 0.7px; text-transform: uppercase; border-bottom: 2px solid #e2e8f0; background: #f8fafc; }
    .pfr-tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
    .pfr-tr:hover td { background: #f8faff; }
    .pfr-td { padding: 12px 16px; vertical-align: top; }
    @keyframes spin { to { transform: rotate(360deg); } }
    .pfr-spinner { width: 32px; height: 32px; border: 3px solid #e2e8f0; border-top-color: #3b82f6; border-radius: 50%; animation: spin 0.7s linear infinite; }
`

const S = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 980, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    breadcrumb: { margin: '0 0 4px', fontSize: '0.78rem', color: '#94a3b8' },
    title: { margin: 0, fontSize: '1.4rem', fontWeight: 700, color: '#0f172a' },
    btnEdit: { padding: '9px 16px', background: 'white', border: '1px solid #e2e8f0', borderRadius: 10, color: '#475569', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif" },
    btnAdd: { padding: '9px 16px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif", boxShadow: '0 4px 12px rgba(59,130,246,0.3)' },
}

export default PersonaFisicaReporteComponent
